import { useMemo } from 'react'

import {
  type DictionaryDto,
  type DictionaryItemValueDto,
} from '@redteclab/api/clients/composition-service-marketplace'

import { useMarketplacePartnerRegisterApiSwrGetDictionaries } from '../api/swr/useMarketplacePartnerRegisterPageFormApiGetDictionaries'

export const useMarketplacePartnerRegisterPageGetDictionaryByName = (
  name: string,
  language: string,
): string[] | undefined => {
  const dictionaries = useMarketplacePartnerRegisterApiSwrGetDictionaries().data

  return useMemo(() => {
    if (!dictionaries) {
      return undefined
    }
    const dictionary: DictionaryDto | undefined = dictionaries.find(
      (dict) => dict.name === name,
    )
    if (!dictionary) {
      return undefined
    }
    const labels = dictionary.items
      .map((item: DictionaryItemValueDto) => {
        const valueForLanguage = item.value.find(
          (val) => val.language === language,
        )

        return valueForLanguage ? valueForLanguage.label : undefined
      })
      .filter((label): label is string => label !== undefined)

    if (labels.length === 0) {
      return undefined
    }

    return labels
  }, [dictionaries, language, name])
}
